import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiEclipseide,
  SiGit,
  SiWindows,
  SiGithub,
  SiApachenetbeanside,
} from "react-icons/si";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiWindows />
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode />
      </Col>
    
      <Col xs={4} md={2} className="tech-icons">
        <SiPostman />
      </Col>
    
      <Col xs={4} md={2} className="tech-icons">
        <SiGit />
      </Col>
    
      <Col xs={4} md={2} className="tech-icons">
        <SiEclipseide />
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <SiGithub />
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <SiApachenetbeanside />
      </Col>
    </Row>
  );
}

export default Toolstack;
